
import {
  IonTitle,
  IonItem,
  IonPage,
  IonContent,
  IonHeader,
  IonRow,
  IonCol,
  IonButton,
  IonInput,
  IonLabel,
  IonButtons,
  IonBackButton,
  IonToolbar,
  toastController
} from '@ionic/vue'
import {defineComponent} from "vue";
import {useRouter} from "vue-router";
import {useI18n} from "vue-i18n";
import firebase from "firebase";
import HomeButton from "@/components/HomeButton.vue";

export default defineComponent({
  components: {
    HomeButton,
    IonTitle,
    IonItem,
    IonPage,
    IonContent,
    IonHeader,
    IonRow,
    IonCol,
    IonButton,
    IonInput,
    IonLabel,
    IonButtons,
    IonBackButton,
    IonToolbar
  },
  name: "ForgotPassword",
  methods: {
    async forgot(event: any) {
      event.preventDefault();
      console.log("test");
      try {

        const data = await firebase.auth().sendPasswordResetEmail(this.email)
        console.log(data);
        this.router.push({name: 'Login'});
        (await toastController.create({
          message: "Wir haben Ihnen eine E-Mail gesendet, mit der Sie Ihr Passwort zurück setzen könnnen",
          color: "success",
          position: "top",
          duration: 2000
        })).present();
      } catch (err) {
        console.log(` failed ${err}`);
        (await toastController.create({message: err.message, color: "danger", position: "top", duration: 2000})).present();
      }
    },
  },
  setup() {
    const router = useRouter()
    const i18n = useI18n()

    return {
      router,
      i18n,
      email: ""
    }
  }
})
